
<!--  -->
<template>
  <div class="study">
    <div class="left">
      <div @click="openChat">
        <img src="@/assets/img/productDetail/icon_custom.png" alt />
        <span>咨询</span>
      </div>
    </div>
    <button class="to-study" :class="[{mini:this.$root.miniprogram}]" @click="study">去学习</button>
  </div>
</template>
<script>
import { setTokenFromCookie, gioEnterCart } from '@/utils/tools';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { setBaseUrl } from '@/utils/tools'

export default {
  props: {
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo', 'courseBaseData']),
  },
  mounted() {},

  methods: {
    study() {
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({ url: '/myCourse/courseList/index' });
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('goLearnCenterPage', {}, false);
      } else {
        this.$router.push({ path: '/personalCenter/mycourseList' });
      }
    },
    openChat() {
      const { baseBusinessLine } = this.courseBaseData;
      const flag = baseBusinessLine && baseBusinessLine === 2; // 判断是否专申本业务线

      const url = `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'689c302a873d7d0001e78a48'}`;

      const baseUrl = setBaseUrl(9);
      // const urlH5 = `${baseUrl}/chat/m_page?probeId=${25}&token=${localStorage.getItem(
      //   'accessToken',
      // )}&landingPageUrl=${window.location.href}`;
      const urlH5 = `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'67653fd704b13300018ae145'}`;
      const urlMini = `${baseUrl}/chat/m_page?probeId=${26}&token=${localStorage.getItem(
        'accessToken',
      )}&landingPageUrl=${window.location.href}`;

      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: flag ? url : urlH5,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        if (flag) {
          wx.miniProgram.navigateTo({
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(
              `https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'689c3a40873d7d0001e78a4c'}`,
            )}&probeId=${'689c3a40873d7d0001e78a4c'}`,
          });
        } else {
          wx.miniProgram.navigateTo({
            // url: `/subPackages/aiChatProdWebview/index?probeId=26`,
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(
              `https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'67653ff19d78140001e5277e'}`,
            )}&probeId=${'67653ff19d78140001e5277e'}`,
          });
        }

        return;
      }
      window.open(flag ? url : urlH5);
    },
    // 查看购物车列表
    goShoppingCar() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login', {}, true).then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
            await this.$parent.getPageDetail();
          });
        } else {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/shoppingCar', beforePageName: 1 },
          });
          gioEnterCart(1);
        }
        return;
      }
      this.$router.push({
        path: '/shoppingCar',
        query: {
          beforePageName: 1,
        },
      });
      gioEnterCart(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.study {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 22px 40px;
  background: #fff;
  .left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    > div {
      padding-right: 30px;
      img {
        display: block;
        width: 48px;
        height: 48px;
      }
      span {
        display: block;
        color: #333;
        font-weight: 400;
        font-size: 20px;
      }
    }
  }
  button.to-study {
    width:598px;
    height: 82px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 82px;
    background: #ff6c02;
    border-radius: 45px;
  }
  button.to-study.mini{
    width: 400px;
  }
}

</style>
